import { Sparkles } from "lucide-react";
import { STARTER_PROMPTS, type StarterPrompt } from "./empty-prompts";

/** Welcome canvas shown until the user runs their first turn. Brand
 *  copy uses the Memso lexicon (recall, weave, synthesize); the word
 *  "brain" is forbidden in user-facing surfaces. */
export function EmptyState({ onPick }: { onPick: (q: string) => void }) {
  return (
    <section className="flex flex-col items-center text-center gap-5 py-10 sm:py-16">
      <div className="inline-flex w-16 h-16 rounded-2xl bg-gradient-to-br from-blue-700 via-blue-600 to-orange-500 items-center justify-center text-white shadow-lg">
        <Sparkles className="w-8 h-8" strokeWidth={2.5} />
      </div>
      <div className="max-w-md space-y-1.5">
        <h2 className="text-xl sm:text-2xl font-bold text-slate-900 dark:text-slate-100">
          Recall, weave, synthesize.
        </h2>
        <p className="text-sm text-slate-500 dark:text-slate-400">
          Ask Memso anything that lives across your captures. It pulls
          the threads it has and synthesizes an answer with sources.
        </p>
      </div>
      <ul className="w-full max-w-2xl lg:max-w-4xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2.5">
        {STARTER_PROMPTS.map((p) => (
          <StarterChip key={p.label} prompt={p} onPick={onPick} />
        ))}
      </ul>
    </section>
  );
}

function StarterChip({
  prompt,
  onPick,
}: {
  prompt: StarterPrompt;
  onPick: (q: string) => void;
}) {
  return (
    <li>
      <button
        type="button"
        onClick={() => onPick(prompt.query)}
        className="group w-full text-left rounded-2xl border border-slate-200/70 dark:border-slate-700/60 bg-white/70 dark:bg-slate-800/40 hover:bg-white dark:hover:bg-slate-800/70 backdrop-blur p-4 transition-colors"
      >
        <div className="text-sm font-semibold text-slate-900 dark:text-slate-100 group-hover:text-blue-700 dark:group-hover:text-blue-300 transition-colors">
          {prompt.label}
        </div>
        <div className="text-xs text-slate-500 dark:text-slate-400 mt-1">
          {prompt.hint}
        </div>
      </button>
    </li>
  );
}
